import * as React from 'react';

import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { Entity } from 'webpanel-admin';
import { SortInfoOrder } from 'webpanel-data';
// import { SortInfoOrder } from "webpanel-data";
import { api } from './api';
import { author } from './author';
import { newsItemCategory } from './newsitem-category';

export const news = new Entity({
  name: 'NewsItem',
  title: 'Aktuality',
  icon: 'notification',
  dataSource: api,
  searchable: true,
  edit: {
    initialValues: { date: new Date() }
  },
  list: {
    initialSorting: [{ columnKey: 'date', order: SortInfoOrder.descend }],
    fields: [
      'title',
      'date',
      {
        field: 'message',
        render: (value: any) => {
          return <Ellipsis length={40}>{value}</Ellipsis>;
        }
      },
      'category',
      'author'
    ]
  }
})
  .inputField('title', {
    title: 'Titulek',
    // visible: ['list', 'edit', 'search'],
    sortable: true,
    filter: true
  })
  .textField('message', { title: 'Text', sortable: true, filter: true })
  .dateField('date', { title: 'Datum', sortable: true })
  .relationshipField('category', {
    title: 'Kategorie',
    type: 'toOne',
    targetEntity: () => newsItemCategory
  })
  .relationshipField('author', {
    title: 'Autor',
    type: 'toOne',
    targetEntity: () => author
  });



// WEBPACK FOOTER //
// ./src/model/news.tsx